import { createSelector } from 'reselect'
import { getVillaViews } from '../view/villa'
import { getItineraryCountries } from 'checkout/lib/utils/cruises/itinerary'
import { getCheckoutCruiseOfferView } from '../view/cruise'
import getBedbankItemViews from '../view/itemViews/getBedbankItemViews'
import getHotelItemViews from '../view/itemViews/getHotelItemViews'
import getTourV2ItemViews from '../view/itemViews/getTourV2ItemViews'
import { getFlightItemsView } from '../view/flights'
import { getAirportsByCode } from 'selectors/flightsSelectors'

const getIsCheckoutLoyaltyInternationalTrip = createSelector(
  (state: App.State) => getCheckoutCruiseOfferView(state),
  (state: App.State) => getBedbankItemViews(state),
  (state: App.State) => getTourV2ItemViews(state),
  (state: App.State) => getHotelItemViews(state),
  (state: App.State) => getVillaViews(state),
  (state: App.State) => getFlightItemsView(state),
  (state: App.State) => getAirportsByCode(state),
  (state: App.State) => state.geo.currentRegionCode.toLowerCase(),
  (cruiseViews, bedbankViews, tourV2Views, hotelViews, villaViews, flightViews, airports, regionCode): boolean => {
    return cruiseViews.data.some(view => {
      return view.offer && getItineraryCountries(view.offer)?.some(country => country.toLowerCase() !== regionCode)
    }) ||
    bedbankViews.data.some(view => {
      return view.offer && view.offer.property.address.countryCode.toLowerCase() !== regionCode
    }) ||
    tourV2Views.data.some(view => {
      const departureIds = view.itemViews.map(view => view.item.purchasableOption.fkVariationId)
      return departureIds.some(departureId => {
        return !!view.offer?.variations[departureId]?.countriesVisited.some(country => country.toLowerCase() !== regionCode)
      })
    }) ||
    hotelViews.data.some(view => {
      return view.offer && view.offer.property!.geoData.countryCode?.toLowerCase() !== regionCode
    }) ||
    villaViews.data.some(view => {
      return view.offer.property.geoData.countryCode?.toLowerCase() !== regionCode
    }) ||
    flightViews.data.some(view => {
      const airport = airports[view.item.destinationAirportCode]
      return airport?.countryCode?.toLowerCase() !== regionCode
    })
  },
)

export default getIsCheckoutLoyaltyInternationalTrip
